<template>
  <div id="qvv_bundesland_timeline">
    <h1>COVID-19-Patienten in den Krankenhäusern</h1>
    <p>
      COVID-19-Patienten in Spitälern und auf Intensivstation, und die
      Veränderung im Vergleich zur Vorwoche.
    </p>
    <div class="graph">
      <table>
        <thead>
          <tr>
            <th></th>
            <th :colspan="mobile ? 2 : 1">Gesamt</th>
            <td v-if="!mobile">Veränderung</td>
            <th :colspan="mobile ? 2 : 1">Intensiv&#x200b;station</th>
            <td v-if="!mobile">Veränderung</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="zeile in tabellendaten"
            :key="zeile.region"
            :class="zeile.region"
          >
            <td>{{ zeile.region }}</td>
            <td class="val">
              {{ $fmt(",d")(zeile["krankenhaus_gesamt_anzahl"]) }}
            </td>
            <td :class="`diff ${zeile.gesamt_rotgruen}`">
              {{
                isNaN(zeile["krankenhaus_gesamt_erhoeht_rate_7t"])
                  ? $fmt("+,d")(zeile["krankenhaus_gesamt_anzahl"])
                  : `${$fmt("+.0f")(
                      zeile["krankenhaus_gesamt_erhoeht_rate_7t"]
                    )}&nbsp;%`
              }}
            </td>
            <td class="val">
              {{ $fmt(",d")(zeile["krankenhaus_intensiv_anzahl"]) }}
            </td>
            <td :class="`diff ${zeile.intensiv_rotgruen}`">
              {{
                isNaN(zeile["krankenhaus_intensiv_erhoeht_rate_7t"])
                  ? $fmt("+,d")(zeile["krankenhaus_intensiv_anzahl"])
                  : `${$fmt("+.0f")(
                      zeile["krankenhaus_intensiv_erhoeht_rate_7t"]
                    )}&nbsp;%`
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <footer>
      <p class="source"><strong>Quelle —</strong> AGES, Stand: {{ stand }}</p>
    </footer>
  </div>
</template>

<script>
import bundeslaender_timeline from "./data/bundeslaender_hospitalisiert_timeline.csv";
import schraegrunter from "./assets/schraegrunter@2x.png";
import gerade from "./assets/gerade@2x.png";
import schraegoben from "./assets/schraegoben@2x.png";
import moment from "moment";

moment.locale("de");

bundeslaender_timeline.map(d => {
  d["krankenhaus_gesamt_erhoeht_um_24h_pct"] = parseFloat(
    d["krankenhaus_gesamt_erhoeht_um_24h_pct"]
  );
  d["krankenhaus_intensiv_erhoeht_um_24h_pct"] = parseFloat(
    d["krankenhaus_intensiv_erhoeht_um_24h_pct"]
  );
  d["krankenhaus_gesamt_anzahl"] = parseInt(d["krankenhaus_gesamt_anzahl"], 10);
  d["krankenhaus_intensiv_anzahl"] = parseInt(
    d["krankenhaus_intensiv_anzahl"],
    10
  );
  return d;
});

export default {
  name: "BundeslandTableKrankenhaus",
  components: {},
  data: () => ({
    bundeslaender_timeline: bundeslaender_timeline,
    mobile: false,
    arrows: {
      schraegrunter,
      gerade,
      schraegoben
    }
  }),
  mounted() {
    window.addEventListener("resize", this.update_mobile);
    this.update_mobile();
  },
  methods: {
    update_mobile() {
      this.mobile = window.innerWidth < 700;
    }
  },
  computed: {
    hoechste_verdopplungszeit() {
      var max = 0;
      this.bundeslaender_timeline.map(d => {
        max = Math.max(max, d.verdopplung_tage);
      });
      return max;
    },
    laendernamen() {
      const values = [
        ...new Set(this.bundeslaender_timeline.map(d => d.region))
      ];
      return values.filter(d => d != "Österreich").concat(["Österreich"]);
    },
    datumswerte() {
      return [...new Set(this.bundeslaender_timeline.map(d => d.stand_proper))];
    },
    land_datumswert_wert() {
      return Object.fromEntries(
        this.laendernamen.map(land => [
          land,
          Object.fromEntries(
            this.datumswerte.map(datum => [
              datum,
              this.bundeslaender_timeline.filter(
                d => d.land == land && d.day == datum
              )[0]
            ])
          )
        ])
      );
    },
    datumswerte_reverse() {
      return this.datumswerte
        .slice()
        .sort()
        .reverse();
    },
    stand() {
      return moment(this.datumswerte_reverse[0], "YYYY-MM-DD hh:mm:ss").format(
        "D.M."
      );
    },
    tabellendaten() {
      const maxdate = this.datumswerte_reverse[0];

      const r = this.bundeslaender_timeline.filter(
        d => d.stand_proper == maxdate
      );

      r.map(d => {
        d.gesamt_rotgruen =
          d["krankenhaus_gesamt_erhoeht_rate_7t"] < -5
            ? "lightgreen"
            : d["krankenhaus_gesamt_erhoeht_rate_7t"] > 5
            ? "red"
            : "yellow";
        d.intensiv_rotgruen =
          d["krankenhaus_intensiv_erhoeht_rate_7t"] < -5
            ? "lightgreen"
            : d["krankenhaus_intensiv_erhoeht_rate_7t"] > 5
            ? "red"
            : "yellow";
      });

      r.sort((a, b) =>
        a.region == "Österreich"
          ? 100
          : b.region == "Österreich"
          ? -100
          : b.krankenhaus_gesamt_erhoeht_um_24h_pct -
            a.krankenhaus_gesamt_erhoeht_um_24h_pct
      );
      return r;
    }
  }
};
</script>

<style scoped>
#qvv_bundesland_timeline {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 21px;
}

h1 {
  font-family: Roboto, sans-serif;
  font-size: 22px;
  line-height: 29px;
  margin-bottom: 12px;
  margin-top: 0;
}

div.graph {
  margin-top: 24px;
  margin-bottom: 24px;
}

footer {
  background: none;
  padding: 0;
  margin: 0;
  display: flex;
}

p.detail {
  font-size: 14px;
  line-height: 21px;
  margin: 0;
}

footer p.source {
  color: #888;
  text-align: right;
  font-size: 11px;
  line-height: 17px;
  margin: 0;
  flex: 1;
  white-space: nowrap;
  padding-top: 1px;
  -webkit-text-size-adjust: 100%;
}
p.source strong {
  font-weight: normal;
  text-transform: uppercase;
}

p {
  line-height: 21px;
  margin: 0px;
}

table {
  width: 100%;
}

td,
th {
  vertical-align: baseline;
}
td >>> svg {
  vertical-align: baseline;
  margin-bottom: -1px;
}

table {
  position: relative;
  border-collapse: collapse;
}

thead tr th,
thead tr td {
  border-bottom: 2px solid black;
  vertical-align: bottom;
}

thead tr th {
  text-align: right;
}

@media (max-width: 700px) {
  thead tr th {
    text-align: center;
  }
}

th {
  text-align: left;
}

td.val {
  text-align: right;
}
td.diff {
  text-align: left;
  width: 77px;
}

@media (max-width: 700px) {
  td.diff {
    width: 65px;
  }
}

tbody tr th,
tbody tr td {
  border-top: 1px solid #ddd;
}
td.val {
  border-left: 1px solid #ddd;
}

tr th,
tr td {
  padding: 5px 5px 0px;
}

tr.Österreich th,
tr.Österreich td {
  border-top: 1px solid black;
}

td.bf,
th.bf {
  padding-right: 10px;
}

td.pct,
th.pct {
  padding-right: 1.75em;
}

td.red {
  background: #ca5775;
  border-top: transparent;
  color: white;
}

td.orange {
  background: #71424f;
  border-top: transparent;
  color: white;
}

td.yellow {
  background: #a6a5a5;
  border-top: transparent;
  color: white;
}

td.lightgreen {
  background: #8cc599;
  border-top: transparent;
  color: white;
}

.outlook img,
p img {
  max-height: 1em;
  max-width: 1em;
}

p img {
  padding-right: 0.3em;
  vertical-align: baseline;
  margin-bottom: -2px;
}

@media (max-width: 700px) {
  table {
    font-size: 12px;
    line-height: 16px;
  }
  tr th,
  tr td {
    padding: 4px 5px 0px;
  }

  p.detail {
    font-size: 11px;
    line-height: 14px;
  }
}
</style>
